import { render, staticRenderFns } from "./SaleEditSaveModalTotalBox.vue?vue&type=template&id=27ab8d83&scoped=true"
import script from "./SaleEditSaveModalTotalBox.vue?vue&type=script&lang=ts"
export * from "./SaleEditSaveModalTotalBox.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditSaveModalTotalBox.vue?vue&type=style&index=0&id=27ab8d83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab8d83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ab8d83')) {
      api.createRecord('27ab8d83', component.options)
    } else {
      api.reload('27ab8d83', component.options)
    }
    module.hot.accept("./SaleEditSaveModalTotalBox.vue?vue&type=template&id=27ab8d83&scoped=true", function () {
      api.rerender('27ab8d83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditSaveModalTotalBox.vue"
export default component.exports